function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// src/ScrollShadowElement.ts
var template = "<slot></slot><s></s><style>:host{display:inline-block;position:relative}:host([hidden]){display:none}s{position:absolute;top:0;bottom:0;left:0;right:0;pointer-events:none;--m:var(--scroll-shadow-size, 14) * 1px;background:var(--scroll-shadow-top,radial-gradient(farthest-side at 50% 0,#0003,#0000)) top/100% min(var(--t),var(--m)),var(--scroll-shadow-bottom,radial-gradient(farthest-side at 50% 100%,#0003,#0000)) bottom/100% min(var(--b),var(--m)),var(--scroll-shadow-left,radial-gradient(farthest-side at 0,#0003,#0000)) left/min(var(--l),var(--m)) 100%,var(--scroll-shadow-right,radial-gradient(farthest-side at 100%,#0003,#0000)) right/min(var(--r),var(--m)) 100%;background-repeat:no-repeat}</style>";
var updaters = /* @__PURE__ */new WeakMap();

var ScrollShadowElement = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ScrollShadowElement, _HTMLElement);

  var _super = _createSuper(ScrollShadowElement);

  function ScrollShadowElement() {
    var _this;

    _classCallCheck(this, ScrollShadowElement);

    _this = _super.call(this);

    _this.attachShadow({
      mode: "open"
    });

    _this.shadowRoot.innerHTML = template;

    _this.shadowRoot.addEventListener("slotchange", function () {
      return _this.connectedCallback();
    });

    updaters.set(_assertThisInitialized(_this), new Updater(_this.shadowRoot.children[1]));
    return _this;
  }

  _createClass(ScrollShadowElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      updaters.get(this).on(this.children[0]);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      updaters.get(this).on();
    }
  }]);

  return ScrollShadowElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var Updater = /*#__PURE__*/function () {
  function Updater(targetElement) {
    var _this2 = this;

    _classCallCheck(this, Updater);

    this.cb = function () {
      return _this2.update(targetElement);
    };

    this.rO = new ResizeObserver(this.cb);
    this.mO = new MutationObserver(function () {
      return _this2.on(_this2.el);
    });
  }

  _createClass(Updater, [{
    key: "on",
    value: function on(element) {
      var _this3 = this;

      if (this.el) {
        this.el.removeEventListener("scroll", this.cb);
        this.rO.disconnect();
        this.mO.disconnect();
      }

      if (!element) return;

      if (element.nodeName === "TABLE" && !/scroll|auto/.test(getComputedStyle(element).getPropertyValue("overflow"))) {
        this.rO.observe(element);
        element = element.tBodies[0];
      }

      element.addEventListener("scroll", this.cb);
      [element].concat(_toConsumableArray(element.children)).forEach(function (el) {
        return _this3.rO.observe(el);
      });
      this.mO.observe(element, {
        childList: true
      });
      this.el = element;
    }
  }, {
    key: "update",
    value: function update(targetElement) {
      var cssText = "--t: ".concat(this.el.scrollTop, "px; --b: ").concat(this.el.scrollHeight - this.el.offsetHeight - this.el.scrollTop, "px; --l: ").concat(this.el.scrollLeft, "px; --r: ").concat(this.el.scrollWidth - this.el.offsetWidth - this.el.scrollLeft, "px;");

      if (this.el.nodeName === "TBODY") {
        var clientRect = this.el.getBoundingClientRect();
        var rootClientRect = this.el.parentElement.getBoundingClientRect();
        cssText += "top: ".concat(clientRect.top - rootClientRect.top, "px; bottom: ").concat(rootClientRect.bottom - clientRect.bottom, "px; left: ").concat(clientRect.left - rootClientRect.left, "px; right: ").concat(rootClientRect.right - clientRect.right, "px;");
      }

      requestAnimationFrame(function () {
        targetElement.style.cssText = cssText;
      });
    }
  }]);

  return Updater;
}(); // src/index.ts


if ("customElements" in window && "ResizeObserver" in window) {
  customElements.define("scroll-shadow", ScrollShadowElement);
}

export { ScrollShadowElement };